export default __webpack_public_path__ + "static/media/orbitz.2a28bb45.png";